export const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '批次包',
        dataIndex: 'pkgCode',
        key: 'pkgCode',
    },
    {
        title: '商品图片',
        dataIndex: 'productImg',
        key: 'productImg',
        scopedSlots: {
            customRender: 'productImgAction'
        }
    },
    {
        title: '商品SKU',
        dataIndex: 'productSku',
        key: 'productSku',
        ellipsis: true,
    },
    {
        title: '商品名称',
        dataIndex: 'productName',
        key: 'productName',
        ellipsis: true,
    },
    {
        title: '移库至',
        dataIndex: 'targetOrg',
        key: 'targetOrg',
        ellipsis: true,
        scopedSlots: {
            customRender: 'targetOrgAction'
        }
    },
    {
        title: '调拨数量',
        dataIndex: 'amount',
        key: 'amount',
        // width: 200,
        // ellipsis: true,
    },
]
const types = ['单品到齐' ,'上架', '多品到齐']
export const testDataSource = [
    {
        id: 0,
        pkgCode: 'GHS03082085334',
        transferAmount: 0,
        transferType: 0,
        productName: '狐狸',
        productImg:  'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
        productSku: 'SKU3429773792',
    },
    {
        id: 10,
        pkgCode: 'KHS03082085334',
        transferAmount: 0,
        transferType: 0,
        productName: '狐狸',
        productImg:  'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
        productSku: 'SKU342977234234',
    }
]